import { Obscura } from '../../vendor';

import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection';
import Pricediscount from '../models/Pricediscount';

const PricediscountsProxy = Obscura.extend({
    getFilterCount () {
        return this.getFilters().length;
    },

    filterByType (val) {
        if(val === "discount_nbr"){
            return this.filterBy("discount_nbr", (model) => {
                return (model.get('discount_nbr') != null);
            });
        }else {
            return this.filterBy('discount_type', (model) => {
                return (model.get('discount_type') == val);
            });
        }
    },

    filterById (val) {
        return this.filterBy('id', (model) => {
            return (model.get('id') == val);
        });
    }
});

export default InboomaBaseAsyncCollection.extend({

    collectionName : 'pricediscounts',
    model : Pricediscount,
    proxy : PricediscountsProxy,
    url : '/pricediscounts'

});
